/**
 * 系统通知相关接口
 * - 前台：我的通知 / 标记已读 / 未读数量
 * - 后台：发送通知 / 管理端列表 / 详情 / 删除
 */
import request from './request'

/**
 * 发送系统通知（管理员/超级管理员）
 * @param {{title:string, content:string, userNos?:string[], allUsers?:boolean, senderNo:string, senderName:string, senderRole:number}} data
 */
export function sendNotice(data) {
  return request.post('/notice/send', data)
}

/**
 * 我的通知列表（分页）
 * @param {{no:string, pageNum:number, pageSize:number}} data
 */
export function myNotices(data) {
  return request.post('/notice/myList', data)
}

/**
 * 标记某条通知为已读
 * @param {{no:string, noticeId:number}} data
 */
export function readNotice(data) {
  return request.post('/notice/read', data)
}

/**
 * 我的未读通知数量
 * @param {string} no
 */
export function unreadCount(no) {
  return request.get('/notice/unreadCount', { params: { no } })
}

/**
 * 管理端通知列表（分页，含已读统计）
 * @param {{pageNum:number, pageSize:number, param:{keyword?:string}}} data
 */
export function manageNotices(data) {
  return request.post('/notice/manageList', data)
}

/**
 * 管理端通知详情（含每个接收人的已读状态）
 * @param {number} noticeId
 */
export function noticeDetail(noticeId) {
  return request.get('/notice/detail', { params: { noticeId } })
}

/**
 * 管理端删除通知
 * @param {{id:number, operatorRole:number, operatorNo:string, operatorName:string}} params
 */
export function deleteNotice(params) {
  return request.get('/notice/del', { params })
}
